import React from "react";
import { useApp } from "../state/AppContext";
import PetalLogo from "../components/PetalLogo";
import { LogIn } from "lucide-react";

export default function LanguageScreen() {
  const { setLang, setScreen, user, pathParam } = useApp();

  const pick = (l) => {
    setLang(l);
    // Spinner path is public — no signup required
    if (pathParam === "spinner") setScreen("activities");
    // Direct kindness link: new visitor → signup wizard, returning user → gallery
    else if (pathParam === "kindness") setScreen(user ? "gallery" : "welcome");
    // Bare URL (no ?path=): show two-path chooser so casual scanners can self-select
    else setScreen("home");
  };

  return (
    <div className="min-h-screen bg-scl-cream flex flex-col items-center justify-center px-6 relative" data-testid="language-screen">
      {/* Top-right Log in — routes to /admin (staff Google sign-in, restricted to @sclk-8.org for now) */}
      <a
        href="/parent"
        data-testid="language-login-btn"
        className="absolute top-4 right-4 sm:top-6 sm:right-6 inline-flex items-center gap-1.5 min-h-[44px] px-4 rounded-full bg-white text-scl-charcoal text-sm font-semibold shadow-warm-sm hover:shadow-warm hover:bg-scl-cream border border-scl-border"
      >
        <LogIn className="w-4 h-4" /> Log in
      </a>
      {/* Staff-only quiet link — small, discoverable but unobtrusive */}
      <a
        href="/admin"
        data-testid="language-staff-link"
        className="absolute bottom-4 right-4 sm:bottom-6 sm:right-6 text-[11px] text-scl-charcoal/45 hover:text-scl-teal underline underline-offset-2"
      >
        Staff sign in
      </a>

      <div className="w-full max-w-sm text-center">
        <div className="mx-auto mb-5 w-20 h-20 rounded-full bg-white flex items-center justify-center shadow-warm">
          <PetalLogo size={64} animated />
        </div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-scl-teal font-semibold mb-2">School for Community Learning</div>
        <h1 className="font-serif text-3xl sm:text-4xl text-scl-charcoal font-bold leading-tight mb-2">
          Choose your language
        </h1>
        <p className="text-scl-charcoal/70 mb-8 text-[15px]">Elige tu idioma</p>

        <button
          onClick={() => pick("en")}
          data-testid="lang-en"
          className="w-full h-14 rounded-2xl bg-scl-coral text-white font-semibold text-lg shadow-warm hover:brightness-105 active:scale-[0.98] transition-all mb-3"
        >
          Continue in English
        </button>
        <button
          onClick={() => pick("es")}
          data-testid="lang-es"
          className="w-full h-14 rounded-2xl bg-scl-teal text-white font-semibold text-lg shadow-warm hover:brightness-105 active:scale-[0.98] transition-all"
        >
          Continuar en Español
        </button>
      </div>
    </div>
  );
}
